import React, { Component } from "react";
import ModalVideo from "react-modal-video";
import "react-modal-video/css/modal-video.css"; // 👈 Importa el CSS aquí

class VideoSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.openVideoModal = this.openVideoModal.bind(this);
    this.closeVideoModal = this.closeVideoModal.bind(this);
  }

  openVideoModal(event) {
    this.setState({ isOpen: true });

    // Tracking del click
    const backendUrl =
      window.location.hostname === "neuralnetadaptivecontrol.com"
        ? "https://controlbook.onrender.com"
        : "http://localhost:3000";

    fetch(`${backendUrl}/clicks`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        sessionId: "session-" + Math.random().toString(36).substr(2, 9),
        elementId: "video-play-btn-es",
        pageUrl: window.location.href,
        elementType: "button",
        userId: "user-react",
        coordinates: event ? { x: event.clientX, y: event.clientY } : null,
        metadata: {
          videoId: "03KBh4VM8-U",
          action: "play",
        },
      }),
    }).catch((err) => console.error("Error tracking video click:", err));
  }

  closeVideoModal() {
    this.setState({ isOpen: false });
  }

  render() {
    return (
      <>
        <section
          className="video-area z-index"
          style={{ marginTop: "50px", marginBottom: "50px" }}
        >
          <div className="container">
            <div className="row">
              <div className="col-12">
                <div className="section-title-wrapper mb-45 text-center">
                  <h5 className="section-subtitle mb-20">short video</h5>
                  <h1 className="section-title mb-35">Video promocional</h1>
                </div>
              </div>
            </div>
            <div className="row justify-content-center">
              <div className="col-lg-8">
                <div
                  className="kvideo-wrapper text-center"
                  data-aos="zoom-in"
                  data-aos-duration="1000"
                >
                  <div
                    className="kvideo position-relative"
                    style={{
                      backgroundImage: `url("/assets/images/bg/video-bg2.png")`,
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                      borderRadius: "12px",
                      padding: "300px 0",
                    }}
                  >
                    <div className="kvideo-sign text-center">
                      <button
                        className="play-btn"
                        onClick={this.openVideoModal}
                        style={{
                          background: "rgba(255,255,255,0.8)",
                          border: "none",
                          borderRadius: "50%",
                          width: "70px",
                          height: "70px",
                          cursor: "pointer",
                        }}
                      >
                        <i className="fas fa-play"></i>
                      </button>
                      {/*<h2 style={{ marginTop: "15px", color: "#fff" }}>
                        Watch Video
                      </h2>*/}
                    </div>
                    <div className="kvideo-number" style={{ marginTop: "20px" }}>
                      {/*<span style={{ display: "block", color: "#fff" }}>
                        mi compañia
                      </span>
                      <a href="tel:6668880000" style={{ color: "#fff" }}>
                        666 888 0000
                      </a>*/}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Modal centrado */}
        <ModalVideo
          channel="youtube"
          isOpen={this.state.isOpen}
          videoId="z24QpRT0mS8"
          onClose={this.closeVideoModal}
        />
      </>
    );
  }
}

export default VideoSection;
